import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import { useEffect, useState } from "react";

function Navbar({ ProjectName, ProjectLogo }) {
    const { t, i18n } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const scrollToSection = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
        setMenuOpen(false);
    };

    useEffect(() => {
        changeLanguage('id');
        const handleScroll = () => {
            setScrolled(window.scrollY > 1000);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const menuItems = ["unit", "harga", "testimoni", "kontak"];

    return (
        <header className={`fixed top-0 left-0 w-full z-50 shadow-md transition-colors duration-300 
            ${scrolled ? "bg-black" : "bg-black md:bg-black/40 md:backdrop-blur-md"}`}>
            <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
                <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection("hero")}>
                    {ProjectLogo && (
                        <img src={ProjectLogo} alt="Logo" className="w-20 h-10 mr-3 object-cover" />
                    )}
                </div>

                {/* Desktop Menu */}
                <nav className="hidden md:flex gap-8 items-center">
                    {menuItems.map((item) => (
                        <button
                            key={item}
                            onClick={() => scrollToSection(item)}
                            className={`font-medium pb-1 border-b-2 border-transparent transition duration-200
                                ${scrolled ? "text-white hover:text-green-700 hover:border-green-600" : "text-white hover:text-green-600"}`}
                        >
                            {t(item)}
                        </button>
                    ))}
                    <Button
                        className="bg-gradient-to-r from-green-600 to-green-800 text-white px-5 py-2 rounded-lg shadow hover:brightness-110 transition"
                        onClick={() => scrollToSection("kontak")}
                    >
                        {t("pesan_sekarang")}
                    </Button>

                    {/* Language Switch */}
                    <select onChange={(e) => changeLanguage(e.target.value)} className="ml-4 border rounded px-2 py-1">
                        <option value="id">🇮🇩 ID</option>
                        <option value="en">🇺🇸 EN</option>
                    </select>
                </nav>

                {/* Mobile menu toggle */}
                <div className="md:hidden">
                    <button onClick={() => setMenuOpen(!menuOpen)} className="focus:outline-none">
                        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            {menuOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>
            </div>

            {/* Mobile Dropdown */}
            {menuOpen && (
                <div className="md:hidden bg-black px-6 pb-4 pt-2 space-y-3 shadow-inner transition-all duration-300">
                    {menuItems.map((item) => (
                        <button
                            key={item}
                            onClick={() => scrollToSection(item)}
                            className="block w-full text-left text-white font-medium hover:text-green-600"
                        >
                            {t(item)}
                        </button>
                    ))}
                    <Button
                        className="w-full mt-3 bg-gradient-to-r from-green-600 to-green-800 text-white py-2 rounded-md shadow hover:brightness-110"
                        onClick={() => scrollToSection("kontak")}
                    >
                        {t("pesan_sekarang")}
                    </Button>

                    {/* Language Switch in mobile */}
                    <select onChange={(e) => changeLanguage(e.target.value)} className="w-full border rounded px-2 py-1 mt-2">
                        <option value="id">🇮🇩 ID</option>
                        <option value="en">🇺🇸 EN</option>
                    </select>
                </div>
            )}
        </header>
    );
}

export default Navbar;